'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);
        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _lodash = require('lodash');
var _all = require('../../../vendor/gsap/all');
var _ThrowPropsPlugin = require('../../../vendor/gsap/ThrowPropsPlugin');
var _ThrowPropsPlugin2 = _interopRequireDefault(_ThrowPropsPlugin);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

// eslint-disable-line

var Slider = function () {
  function Slider(track, settings, activeSlide) {
    _classCallCheck(this, Slider);
    this.state = {
      activeSlide: activeSlide,
      centerIsDisabled: false,
      draggableTrack: null,
      dragIsDisabled: false,
      slides: track.childNodes,
      track: track
    };
    var defaultSettings = {
      customClickEvent: false,
      disableDrag: false,
      dots: true,
      initialSlide: 0,
      handleSlideUpdate: function handleSlideUpdate() {
        console.error('A handleSlideUpdate function must be defined in slider settings.'); // eslint-disable-line
      },
      toggleSlideClick: false,
      responsive: {
        breakpoint: 0,
        disableCenter: false,
        disableDrag: false
      }
    };
    this.settings = (0, _lodash.defaultsDeep)(settings, defaultSettings);
    this.onDotClick = this.onDotClick.bind(this);
    this.handleResponsiveDrag = this.handleResponsiveDrag.bind(this);
    this.handleResponsiveCenter = this.handleResponsiveCenter.bind(this);
    this.initCenter();
    this.initDrag();
    this.initSlides();
    this.initDots();
  }
  _createClass(Slider, [{
    key: 'initCenter',
    value: function initCenter() {
      this.handleResponsiveCenter();
      window.addEventListener('resize', (0, _lodash.debounce)(this.handleResponsiveCenter, 300));
    }
  }, {
    key: 'initDrag',
    value: function initDrag() {
      if (this.settings.disableDrag) return;
      if (this.settings.responsive.disableDrag) {
        this.handleResponsiveDrag();
        window.addEventListener('resize', (0, _lodash.debounce)(this.handleResponsiveDrag, 300));
      } else {
        this.createDrag();
        this.updateSnapPoints();
      }
    }
  }, {
    key: 'initSlides',
    value: function initSlides() {
      var _this = this;
      if (this.settings.initialSlide < 0 || this.settings.initialSlide > this.state.slides.length - 1) {
        console.error('initialSlide value must be a valid index in array.'); // eslint-disable-line
      }
      if (this.settings.customClickEvent) return;
      this.state.slides.forEach(function (slide) {
        slide.addEventListener('click', function (e) {
          e.preventDefault();
          _this.onSlideClick(slide);
        });
      });
    }
  }, {
    key: 'initDots',
    value: function initDots() {
      if (!this.settings.dots) this.hideDots();
    }
  }, {
    key: 'onSlideClick',
    value: function onSlideClick(slide) {
      var activeSlide = void 0;
      if (this.settings.toggleSlideClick) {
        activeSlide = this.state.activeSlide !== slide ? slide : null;
      } else {
        activeSlide = slide;
      }
      this.updateActiveSlide(activeSlide);
      if (!this.state.centerIsDisabled) {
        this.centerElement(this.getCenterElement());
      }
    }
  }, {
    key: 'onDotClick',
    value: function onDotClick(dotIndex) {
      var pairedSlide = Array.from(this.state.slides).filter(function (slide, index, array) {
        return array.indexOf(slide) === dotIndex;
      })[0];
      if (pairedSlide !== this.state.activeSlide) {
        this.updateActiveSlide(pairedSlide);
        this.centerElement(pairedSlide);
      }
    }
  }, {
    key: 'handleResponsiveCenter',
    value: function handleResponsiveCenter() {
      if (this.settings.responsive.disableCenter) {
        if (window.innerWidth < this.settings.responsive.breakpoint) {
          this.state.centerIsDisabled = false;
          this.centerElement(this.getCenterElement());
        } else if (!this.state.centerIsDisabled) {
          this.disableCenter();
        }
      } else {
        this.centerElement(this.getCenterElement());
      }
    }
  }, {
    key: 'centerElement',
    value: function centerElement(el) {
      var _this2 = this;
      _all.TweenMax.to(this.state.track, 0.4, {
        x: this.getCenterOffset(el),
        ease: _all.Power1.easeOut,
        onComplete: function onComplete() {
          if (!_this2.state.dragIsDisabled && _this2.state.draggableTrack) {
            _this2.state.draggableTrack.update(); // gsap method
          }
        }
      });
    }
  }, {
    key: 'getCenterElement',
    value: function getCenterElement() {
      var el = void 0;
      if (this.state.activeSlide) {
        el = this.state.activeSlide;
      } else if (!this.state.dragIsDisabled && window.innerWidth < this.settings.responsive.breakpoint) {
        el = this.state.slides[this.settings.initialSlide];
      } else if (!this.settings.responsive.breakpoint) {
        el = this.state.slides[this.settings.initialSlide];
      } else {
        el = this.state.track;
      }
      return el;
    }
  }, {
    key: 'getCenterOffset',
    value: function getCenterOffset(el) {
      var elRect = el.getBoundingClientRect();
      var windowCenter = window.innerWidth / 2;
      var offset = void 0;
      if (el === this.state.track) {
        offset = windowCenter - elRect.width / 2;
      } else {
        // Since Rect.x is the position of element relative to its parent container
        // we need to subtract the parent's x postion from the center of slide
        var slideCenterPosition = elRect.width / 2 + elRect.x;
        var trackXPosition = el.parentNode.getBoundingClientRect().x;
        var slideOffset = slideCenterPosition - trackXPosition;
        offset = windowCenter - slideOffset;
      }
      return offset;
    }
  }, {
    key: 'disableCenter',
    value: function disableCenter() {
      _all.TweenMax.set(this.state.track, {
        x: 0
      });
      this.state.centerIsDisabled = true;
    }
  }, {
    key: 'handleResponsiveDrag',
    value: function handleResponsiveDrag() {
      if (window.innerWidth < this.settings.responsive.breakpoint) {
        if (!this.state.draggableTrack) {
          this.createDrag();
        } else if (this.state.draggableTrack && this.state.dragIsDisabled) {
          this.enableDrag();
        }
        this.updateSnapPoints();
      } else if (this.state.draggableTrack && !this.state.dragIsDisabled) {
        this.disableDrag();
      }
    }
  }, {
    key: 'createDrag',
    value: function createDrag() {
      var _this3 = this;
      var _Draggable$create = _all.Draggable.create(this.state.track, {
          dragClickables: true,
          edgeResistance: 0.5,
          minDuration: 0.3,
          maxDuration: 0.4,
          throwProps: true,
          throwResistance: 999999,
          type: 'x',
          snap: {
            x: []
          },
          onThrowComplete: function onThrowComplete() {
            return _this3.onThrowComplete();
          }
        }),
        _Draggable$create2 = _slicedToArray(_Draggable$create, 1),
        draggableTrack = _Draggable$create2[0];
      this.state.draggableTrack = draggableTrack;
    }
  }, {
    key: 'onThrowComplete',
    value: function onThrowComplete() {
      var snapPoints = this.state.draggableTrack.vars.snap.x;
      var activeDragIndex = snapPoints.indexOf(this.state.draggableTrack.x);
      var activeSlide = this.state.slides[activeDragIndex];
      this.updateActiveSlide(activeSlide);
    }
  }, {
    key: 'enableDrag',
    value: function enableDrag() {
      this.state.draggableTrack.enable(); // gsap method
      this.state.dragIsDisabled = false;
    }
  }, {
    key: 'disableDrag',
    value: function disableDrag() {
      this.state.draggableTrack.kill(); // gsap method
      this.state.dragIsDisabled = true;
    }
  }, {
    key: 'updateSnapPoints',
    value: function updateSnapPoints() {
      var slide = this.state.slides[0];
      var slideWidth = Math.round(slide.getBoundingClientRect().width);
      var slideStyle = slide.currentStyle || window.getComputedStyle(slide);
      var slideMargin = slideStyle.marginLeft;
      var regDigits = new RegExp(/\d+/g);
      var marginArr = slideMargin.match(regDigits);

      // slide width plus left and right margins
      var fullSlideWidth = Number(marginArr[0] * 2) + slideWidth;
      var offset = (window.innerWidth - fullSlideWidth) / 2;
      var snapPointsArr = [];

      // Increment the offset by the fullSlideWidth and push new point to array
      this.state.slides.forEach(function (el, index) {
        var point = offset - index * fullSlideWidth;
        snapPointsArr.push(point);
      });
      // update gsap draggableTrack snap.x array
      this.state.draggableTrack.vars.snap.x = snapPointsArr;
    }
  }, {
    key: 'updateActiveSlide',
    value: function updateActiveSlide(slide) {
      this.state.activeSlide = slide;
      this.settings.handleSlideUpdate(this);
    }
  }]);
  return Slider;
}();
exports.default = Slider;